import { BscNotificationUserEntity } from "../entities/bscNotificationUser.entity";

export class BscNotificationModel{
    mails:BscNotificationUserEntity[];
    variables:string[];

    constructor(){}
}